import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';

import ogImage from 'assets/images/evolaskly.png';

type Props = {
  seoData?: SeoDataType;
  ogData?: OgDataType;
};

const seoDataSystem = {
  title: 'Ask2Auto - AI Chatbot for your Business',
  description: 'Ask2Auto is an intelligent AI chatbot platform that helps businesses automate customer support, internal training, and knowledge access. Easy to deploy, powerful to scale.',
  keywords: 'Ask2Auto, AI chatbot, business chatbot, customer support AI, knowledge base bot, AI assistant for business, chatbot for website',
  metaRobot: '',
  structureData: '',
  metaViewport: '',
  canonicalUrl: '',
  image: ogImage,
  noIndex: false
};
const HelmetComponent: React.FC<Props> = ({ seoData, ogData }) => {
  const helmetData = useMemo(() => ({
    title: seoData?.title || seoDataSystem?.title,
    description: seoData?.description || seoDataSystem?.description,
    keywords: seoData?.keywords || seoDataSystem?.keywords,
    metaRobot: seoData?.metaRobot || seoDataSystem?.metaRobot,
    structureData: seoData?.structureData || seoDataSystem?.structureData,
    metaViewport: seoData?.metaViewport || seoDataSystem?.metaViewport,
    canonicalUrl: seoData?.canonicalUrl || seoDataSystem?.canonicalUrl,
    image: seoData?.image || seoDataSystem?.image,
    noIndex: seoData?.noIndex,
    ogTitle: ogData?.facebook?.title || seoData?.title || seoDataSystem?.title,
    ogDescription: ogData?.facebook?.description || seoData?.description
      || seoDataSystem?.description,
    ogImage: ogData?.facebook?.image || seoDataSystem.image,
    twTitle: ogData?.twitter?.title || seoData?.title || seoDataSystem?.title,
    twDescription: ogData?.twitter?.description || seoData?.description
      || seoDataSystem?.description,
  }), [seoData, ogData]);

  const removePrefixCanonical = (link: string) => (link.substring(link.length - 1) === '/' ? link.substring(0, link.length - 1) : link);
  return (
    <Helmet>
      <link rel="alternate" href={window.location.href} hrefLang="vi-vn" />
      {helmetData?.title && <title>{helmetData.title}</title>}
      {helmetData?.description && <meta name="description" content={helmetData.description} />}
      {helmetData?.keywords && <meta name="keyword" content={helmetData.keywords} />}
      <link rel="canonical" href={removePrefixCanonical(helmetData.canonicalUrl || window.location.origin + window.location.pathname)} />
      <meta property="og:url" content={window.location.href} />
      {helmetData?.noIndex && <meta name="robots" content="noindex" />}
      {helmetData.ogTitle && <meta property="og:title" content={helmetData.ogTitle} />}
      {helmetData.ogDescription && <meta property="og:description" content={helmetData.ogDescription} />}
      {helmetData.ogImage && <meta property="og:image" content={helmetData.ogImage} />}
      {helmetData.twTitle && <meta name="twitter:title" content={helmetData.twTitle} />}
      {helmetData.twDescription && <meta name="twitter:description" content={helmetData.twDescription} />}
    </Helmet>
  );
};

export default HelmetComponent;
